// extracted by mini-css-extract-plugin
export default {"text":"NotificacaoContentText_text__QGPZZ"};